export const blobToString = (
  blob: Uint8Array<ArrayBufferLike> | null
): any | null =>
  blob
    ? JSON.parse(new TextDecoder().decode(new Uint8Array(Object.values(blob))))
    : null
